
import {userApi} from './user'


console.log('🔗 LOADING: usertrustchainsget.js');


export const userTrustchainApi = userApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserTrustchain: builder.query({      
      query: (userId) => {
        console.log('🔗 EXECUTING: getUserTrustchain query');
        return `/trusteduser/chain/${userId}`;
      },
    }),
    

  }),
  overrideExisting: false,
})

export const { useGetUserTrustchainQuery, usePrefetch } = userTrustchainApi